// extracted by mini-css-extract-plugin
export default {"wrap":"countdown_wrap__t2o3l","countdown":"countdown_countdown__voHNu"};